import { render, staticRenderFns } from "./solicitacao.vue?vue&type=template&id=63278e55&"
import script from "./solicitacao.vue?vue&type=script&lang=js&"
export * from "./solicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports